import {createAction} from 'redux-act';

export const OPEN_ADJUST_MODAL = createAction(
  'orderAdjustV2/OPEN_ADJUST_MODAL'
);
export const CALCULATE_ADJUST = createAction('orderAdjustV2/CALCULATE_ADJUST');
export const CALCULATE_ADJUST_SUCCESS = createAction(
  'orderAdjustV2/CALCULATE_ADJUST_SUCCESS'
);
export const CREATE_ADJUST = createAction('orderAdjustV2/CREATE_ADJUST');
export const OPEN_ADJUST_SUCCESS_MODAL = createAction(
  'orderAdjustV2/OPEN_ADJUST_SUCCESS_MODAL'
);
export const OPEN_ADJUST_ERROR_MODAL = createAction(
  'orderAdjustV2/OPEN_ADJUST_ERROR_MODAL'
);
